import axiosInstance from '../../utils/axiosInstance';
const API_URL = process.env.REACT_APP_API_INVOICE;

export const getInvoices = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const response = await axiosInstance.get(`${API_URL}?${queryString}`);
  return response.data;
};

export const getActiveInvoices = async () => {
  const response = await axiosInstance.get(`${API_URL}/active`);
  return response.data;
};

export const generateInvoice = async (invoice) => {
  const response = await axiosInstance.post(`${API_URL}/calculate-tax`, invoice);
  return response;
}

export const downloadPDF = async (invoice) => {
  const response = await axiosInstance.post(`${API_URL}/download`, invoice, {
    responseType: 'blob',
  });
  return response;
}

export const commitTransacition = async (invoice) => {
  const response = await axiosInstance.post(`${API_URL}/commit`, invoice);
  return response;
}

export const voidTransacition = async (invoice) => {
  const response = await axiosInstance.post(`${API_URL}/void`, invoice);
  return response;
}

export const getCustomerInvoices = async (customer_id) => {
  const response = await axiosInstance.get(`${API_URL}/customer-invoices/${customer_id}`)
  return response.data;
}

export const changeStatus = async (data) => {
  const response = await axiosInstance.post(`${API_URL}/change-status`, data);
  return response;
}
